import { refreshProfileWalkInsCache, walkInQueryKeys } from '@/hooks/queries/walk-in.queries';
import { useAuth } from '@/hooks/useAuth';
import { WalkInService } from '@/services/walk-in.service';
import type { CreateWalkInQueueRequestDto } from '@/types/dto/walk-in.dto';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useCreateWalkInQueue() {
  const queryClient = useQueryClient();
  const { user } = useAuth();
  const mutation = useMutation({
    mutationFn: (payload: CreateWalkInQueueRequestDto) => WalkInService.create(payload),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: walkInQueryKeys.all });
      await refreshProfileWalkInsCache(queryClient, user?.id);
    },
  });

  return {
    createWalkInQueue: mutation.mutateAsync,
    error: mutation.error,
    isError: mutation.isError,
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess,
  };
}
